import {
  prepareOptionsChartLegends,
  prepareOptionsForControls
} from '@aytm/app/stats/page/question-views/bpm/lib/utils'
import { PLOT_VALUES } from '@aytm/app/stats/page/question-views/bpm/components/tv/lib/constants'
import { calcPlaceholderMultiSelect } from '@aytm/app/stats/page/question-views/components/lib/select-utils'

const getHiddenPlaceholderFactory =
  (singular, plural) =>
  (value = [], data = []) =>
    calcPlaceholderMultiSelect(value, data, {
      empty: 'Show all',
      multiple: count => {
        const hidden = data.length - count
        return `${hidden} ${hidden === 1 ? `${singular} is` : `${plural} are`} hidden`
      }
    })

export const getHiddenEntityPlaceholder = getHiddenPlaceholderFactory('entity', 'entities')

export const getHiddenAttributesPlaceholder = getHiddenPlaceholderFactory('attribute', 'attributes')

export const getDefaultValues = ({ defaultPlotByValue, questionVariants = [], batches = [] }) => {
  return {
    p: defaultPlotByValue || PLOT_VALUES.e,

    e: {
      e: '-1',
      a: '-2'
    },

    b: questionVariants.map(v => String(v.position)),
    a: batches.map(v => String(v.position))
  }
}

const getDefaultOption = (isBayesian, value, type) => {
  return {
    value,
    text: `${isBayesian ? 'Bayesian averaged' : 'Total'} scores for each ${type}`
  }
}

export const getTvElevationsRepresentOptions = ({
  tvPlotByValue,
  answer,
  questionVariants,
  chartLegendMode,
  batches
}) => {
  const isBayesian = answer?.mds?.version >= 3

  if (tvPlotByValue === PLOT_VALUES.e) {
    return [
      getDefaultOption(isBayesian, '-1', 'entity'),
      ...prepareOptionsChartLegends(questionVariants, chartLegendMode)
    ]
  }

  return [getDefaultOption(isBayesian, '-2', 'attribute'), ...prepareOptionsForControls(batches)]
}
